<template>
	<layout-page title="Start">
		<!-- title -->
		<div
			class="bg-green px-4 sm:px-6 py-4 lg:rounded-tl-2xl xl:rounded-t-2xl flex justify-start items-center"
		>
			<h1 class="text-2xl md:text-4xl font-semibold text-white">
				{{ heading }}
			</h1>
		</div>

		<div
			class="px-4 sm:px-6 lg:px-6 py-6 bg-gray-100 flex-grow flex flex-col space-y-6"
		>
			<start-nearby-offers
				:offers="nearbyOffers"
				:user="user"
				v-if="nearbyOffers.length > 0"
			/>

			<div
				v-if="user.type == 'FARMER'"
				class="bg-gray-700 rounded-xl p-4 grid grid-flow-row-dense grid-cols-1 lg:grid-cols-5 grid-rows-1"
			>
				<div class="col-span-4 text-center grid items-center">
					<p class="text-gray-100 text-xl font-semibold">
						{{ __("price_calculator_banner_text") }}
					</p>
				</div>
				<div class="text-center pt-4 lg:pt-0.5">
					<a
						v-bind:href="priceCalculatorHref"
						target="_blank"
						class="truncate bg-orange-500 text-white px-4 py-1.5 font-medium rounded-lg focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400 border border-orange shadow-sm hover:bg-orange-600 focus:outline-none font-medium"
						type="button"
						>{{ __("price_calculator_button_caption") }}</a
					>
				</div>
			</div>

			<!-- be aware of the safari grid height bug -->
			<!-- no effect min-h-0 min-w-0 -->
			<div
				class="flex-grow flex rounded-xl overflow-hidden bg-white shadow"
				style="max-height: 800px"
			>
				<div class="grid sm:gap-x-2 sm:grid-cols-3">
					<start-offers-map
						:offers="recentOffers"
						:center="mapCenter"
						:class="sideContentComponent ? 'sm:col-span-2' : 'col-span-3'"
					/>
					<component
						class=""
						v-bind:is="sideContentComponent"
						:user="user"
					v-if="sideContentComponent"
					/>
				</div>
			</div>
		</div>
	</layout-page>
</template>

<script>
export default {
	props: {
		nearbyOffers: {
			type: Array,
			required: true,
		},
		recentOffers: {
			type: Array,
			required: true,
		},
		mapCenter: {
			type: Object,
			default: null,
		},
		noOfferActive: {
			type: Boolean,
			default: true,
		},
		user: {
			type: Object,
			required: true,
		},
		acl: {
			type: Object,
			required: true,
		},
		showUpgradeProfileModal: {
			type: Boolean,
			default: false,
		},
		showCreateOffer: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			showCompleteProfileModal:
				(window.location.hash || "").indexOf("complete_profile") != -1 ||
				this.acl.needs_complete_profile,
			activeOffersCount: this.$inertia.page.props.mapMeta.activeOffersCount,
			heading:
				this.nearbyOffers[0]?.trade == "SELL"
					? __("Current sell offers from your region")
					: __("Current buy offers from your region"),
			priceCalculatorHref:
				"https://preisrechner.cropspot.com/?uid=" + this.user.id,
		};
	},
	mounted() {
		if (this.showCompleteProfileModal) {
			this.$bus.$emit(
				"toggle-iframe-modal",
				this.$route("user.complete_profile", { iframe_modal: true }),
				true,
				false
			);
		} else if (this.showUpgradeProfileModal) {
			this.$bus.$emit(
				"toggle-iframe-modal",
				this.$route("user.upgrade_profile", { iframe_modal: true }),
				true,
				false
			);
		} else if (this.showCreateOffer) {
			this.$bus.$emit(
				"toggle-iframe-modal",
				this.$route("offers.create", { iframe_modal: true }),
				true,
				false
			);
		}
	},
	computed: {
		sideContentComponent() {
			if (this.acl.needs_complete_profile) {
				return "content-start-side-needs-complete-profile";
			} else if (!this.acl.active_user) {
				return "content-start-side-needs-activation";
			} else if (this.activeOffersCount == 0) {
				return "content-start-side-no-active-offers";
			} else {
				return "content-start-side-no-active-offers";
				//return 'content-start-side-has-active-offers';
				//content-start-side-has-active-offers;
			}
		},
	},
};
</script>
